import { render, staticRenderFns } from "./CgSubShelvesManage.vue?vue&type=template&id=1c0b9f78&scoped=true"
import script from "./CgSubShelvesManage.vue?vue&type=script&lang=js"
export * from "./CgSubShelvesManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0b9f78",
  null
  
)

export default component.exports